module.exports = __webpack_public_path__ + "static/media/README.d9d4dd54.md";